import Config from 'constants/Config';

const GoogleMapUtils = {

  getApiUrlWithVersion: () => {
    return `${Config.Google.Map.API_URL}?key=${Config.Google.Map.API_KEY}&v=${Config.Google.Map.API_VERSION}`;
  }
}


export default GoogleMapUtils;
